export default {
  ALLIANZ_ACCOUNT_STATEMENT_REPOSITORY: Symbol.for('ALLIANZ_ACCOUNT_STATEMENT_REPOSITORY'),
  ALLIANZ_ACCOUNT_STATEMENT_STATE_MANAGER: Symbol.for('ALLIANZ_ACCOUNT_STATEMENT_STATE_MANAGER'),
  SEARCH_ALLIANZ_ACCOUNT_STATEMENTS_QUERY: Symbol.for('SEARCH_ALLIANZ_ACCOUNT_STATEMENTS_QUERY'),
  DOWNLOAD_ALLIANZ_ACCOUNT_STATEMENT_QUERY: Symbol.for('DOWNLOAD_ALLIANZ_ACCOUNT_STATEMENT_QUERY'),
};
